import React, { Component } from 'react';
import Link from 'next/link';
import * as ST from './styled';

const citiesForbidden = ['taishet'];

export class FooterLinks extends Component {
    state = {
        links: [],
    };

    constructor(props) {
        super(props);
        this.state.links = props.linkList;
    }

    componentDidMount() {
        this.initLinks();
    }

    componentDidUpdate(prevProps) {
        const { citydomain, token } = this.props;
        if (prevProps.citydomain !== citydomain || prevProps.token !== token) {
            this.initLinks();
        }
    }

    initLinks() {
        const { linkList } = this.props;
        const links = linkList.map((item) => (
            this.getLink(item)
        ));
        this.setState({ links });
    }

    getLink = (link) => {
        const { citydomain } = this.props;
        let url = link.link;
        if (link.params !== undefined && link.params.length > 0) {
            url += this.getParamsString(link.params);
        }
        url = url.replace('%city%', citydomain);
        return {
            text: link.text,
            link: url
        };
    };

    getParamsString = (params) => {
        const { citydomain, billingDomain, token } = this.props;
        let paramsString = '';
        params.forEach((param) => {
            let value = param.value.replace('%city%', citydomain);
            value = value.replace('%billingDomain%', billingDomain);
            value = value.replace('%token%', token);
            if (value.length > 0) {
                paramsString = paramsString + '&' + param.name + '=' + value;
            }
        });
        return paramsString.replace('&', '?');
    }

    render() {
        const { title, citydomain } = this.props;
        const { links } = this.state;
        return (
            <ST.FooterLinks>
                <ST.LinksTitle >{title}</ST.LinksTitle>
                <ST.LinksList >
                    {links.map((item, index) => {
                        const isTelephoneLink = item.link === '/telephone';
                        const isForbiddenCity = citiesForbidden.includes(citydomain);

                        if (isTelephoneLink && isForbiddenCity) {
                            return null;
                        }

                        return (
                            <ST.ListItem key={index}>
                                <Link href={item.link} prefetch={false}>
                                    <ST.ListItemA href={item.link}>{item.text}</ST.ListItemA>
                                </Link>
                            </ST.ListItem>
                        );
                    })}
                </ST.LinksList>
            </ST.FooterLinks>
        );
    }
}
